import { render } from "./size-selector.vue?vue&type=template&id=686a9772"
import script from "./size-selector.vue?vue&type=script&lang=js"
export * from "./size-selector.vue?vue&type=script&lang=js"

import "./size-selector.vue?vue&type=style&index=0&id=686a9772&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__